/*
 *   File : App.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

//Custom components
import { ForgotPassword, Login, SetPassword } from './Container/Auth';
import { Dashboard, Notifications } from './Container/Dashboard';
import { Footer } from './Components/Footer';
import { Header } from './Components/Header';
import { FundOrderDetail, GoalOrderDetail, OrderList } from './Container/Orders';
import { CustomerDetail, GroupDetail, List } from './Container/Customer';
import { LeftNavigation } from './Components/Navigation';
import { BasketListing, ManageBasket, RebalanceHistory } from './Container/Basket';
import { PushNotifications, CreatePushNotification } from './Container/PushNotifications';
import { GeneralContent } from './Container/GeneralContent';
import { AdminDetail, SubAdminList } from './Container/SubAdmins';
import { Reports } from './Container/Reports';
import { LeadsList, LeadDetail } from './Container/Leads';
import { NonKyc, NonKycDetail } from './Container/NRIKYC';
import { DocumentDetail, DocumentList } from './Container/Documents';
import { EditLog, ManageQuestionnaire, ManageRisk, QuestionList } from './Container/Risk';
import { CustomerSupport } from './Container/CustomerSupport';
import { PrimeData } from './Container/Prime';
import Toast from './Components/Others/toast-container';
import OrderDetail from './Container/Orders/order-detail';
import { PageNotFound } from './Components/Others';
import { ManageMail, ManageTemplate, SendMail } from './Container/SendMail';
import { Config } from './Container/Config';
import Store from './Store/store';
import { APIService } from './Service';
import { OpsDashboard } from './Container/OPS';
import { SIP, SWP, STP } from './Container/SystematicPlan';
import ErrorBoundary from './Components/Others/error';
import { ApiHistory, CronStatusHistory } from './Container/OPS/Helper';
import { ManageBanner } from './Container/Banner';
import FundSchemeList from './Container/FundScheme/list';
import { OtherTransactionsList } from './Container/OtherTransactions';


function App() {

    const profileFetchedRef = useRef(false);
    const TOKEN = Cookies.get("access_token");
    const [toggle, setToggle] = useState(false);
    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);
    const [showLoading, setShowLoading] = useState(true);
    const NAV_ACCESS_ITEMS = [
        { path: "/", short_name: "Dashboard" },
        { path: "/ops", short_name: "OPS Dashboard" },
        { path: "/customers", short_name: "Customer", short_names: ["Customer", "Bank Verification","User Group"] },
        { path: "/orders", short_name: "Order" },
        { path: "/sip", short_name: "SIP" },
        { path: "/baskets", short_name: "Manage Basket" },
        { path: "/risk-assessment", short_name: "Risk Assesment" },
        { path: "/push-notification", short_name: "Push Notification" },
        { path: "/monthly-reports", short_name: "Monthly Reports" },
        { path: "/revenue", short_name: "Revenue" },
        { path: "/send-mail", short_name: "Send Mail" },
        { path: "/leads", short_name: "Leads" },
        { path: "/other-transactions", short_name: "Switch/SWP/STP", short_names: ["Order", "Switch/SWP/STP"] },
        { path: "/manage-banner", short_name: "Manage Banner" },
        { path: "/sub-admins", short_name: "Manage Sub Admins" },
        { path: "/documents", short_name: "Document & Actions" },
        { path: "/prime-data", short_name: "Prime Data" },
        { path: "/support", short_name: "Support" },
        { path: "/non-kyc-nri", short_name: "Non-KYC NRI" },
        { path: "/config", short_name: "Config" },
    ];

    const matchesModule = (item, moduleName = "") => {
        const supportedNames = item.short_names?.length ? item.short_names : [item.short_name];
        return supportedNames.some((name) => name.toLowerCase() === moduleName.toLowerCase());
    };

    const getAllowedItems = () => {
        if (!PROFILE_DATA?.modules?.length) return [];
        return NAV_ACCESS_ITEMS.filter((item) =>
            PROFILE_DATA.modules.some((mod) => matchesModule(item, mod?.name || ""))
        );
    };

    const getFirstAllowedPath = () => {
        const allowedItems = getAllowedItems();
        const hasDashboard = allowedItems.some((item) => item.short_name.toLowerCase() === "dashboard");
        if (hasDashboard) return "/";
        return allowedItems[0]?.path || "/";
    };

    const hasPathAccess = (path) => {
        if (!PROFILE_DATA?.modules?.length) return false;
        const allowedItems = getAllowedItems();
        return allowedItems.some((item) => path.startsWith(item.path));
    };

    const ProtectedRoute = ({ path, element }) => {
        if (!PROFILE_DATA?.modules?.length) return <Navigate to="/" replace />;
        return hasPathAccess(path) ? element : <Navigate to={getFirstAllowedPath()} replace />;
    };

    useEffect(() => {
        // Removing modal backdrop for all modals when use gesture
        window.addEventListener('popstate', function () {
            if (document.querySelector(".modal-backdrop")) {
                document.querySelector(".modal-backdrop").remove();
                document.body.style.overflow = 'unset';
            };

        });
    }, [window.location.pathname]);

    useEffect(() => {
        if (!TOKEN) return;
        if (profileFetchedRef.current) return;

        profileFetchedRef.current = true;

        if (TOKEN && Object.keys(PROFILE_DATA).length === 0) {
            if (localStorage.getItem('modules')) {
                Store.dispatch({
                    type: 'UPDATE_PROFILE_DATA',
                    payload: JSON.parse(localStorage.getItem('modules'))
                });
            }
            _getProfile();
        }
    }, [TOKEN]);

    const _getProfile = () => {
        let is_post = false;
        let url = 'profile/get';
        let request = {}
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                if (response.data.modules) {
                    Store.dispatch({
                        type: 'UPDATE_PROFILE_DATA',
                        payload: response.data
                    });
                }

            } else {
            }

            setShowLoading(false);
        });
    };
    // useEffect(() => {
    //     const observer = new MutationObserver((mutations) => {
    //         mutations.forEach((mutation) => {
    //             mutation.removedNodes.forEach((node) => {
    //                 if (
    //                     node instanceof HTMLElement &&
    //                     node.classList.contains('modal')
    //                 ) {
    //                     console.log('.modal removed from DOM');

    //                     // Remove all .modal-backdrop elements
    //                     document.querySelectorAll('.modal-backdrop').forEach((el) =>
    //                         el.remove()
    //                     );
    //                 }
    //             });
    //         });
    //     });

    //     observer.observe(document.body, {
    //         childList: true,
    //         subtree: true,
    //     });

    //     return () => {
    //         observer.disconnect();
    //     };
    // }, []);


    // const TIMEOUT = 30 * 60 * 1000; // 30 minutes
    // const timerRef = useRef(null);

    // const resetTimer = () => {
    //     clearTimeout(timerRef.current);
    //     timerRef.current = setTimeout(logoutUser, TIMEOUT);
    // };

    const logoutUser = () => {
        Cookies.remove("access_token", {
            path: '/',
            domain: process.env.REACT_APP_ENV_DOMAIN,
        });
        window.location.replace("/");
    };

    // useEffect(() => {
    //     // List of events to consider as "activity"
    //     const events = ["click", "mousemove", "keypress", "scroll", "touchstart"];

    //     // Attach activity listeners
    //     events.forEach((event) =>
    //         window.addEventListener(event, resetTimer, { passive: true })
    //     );

    //     // Tab visibility change
    //     const handleVisibilityChange = () => {
    //         if (!document.hidden) {
    //             resetTimer();
    //         }
    //     };
    //     document.addEventListener("visibilitychange", handleVisibilityChange);

    //     // Start timer when component mounts
    //     resetTimer();

    //     // Cleanup on unmount
    //     return () => {
    //         events.forEach((event) =>
    //             window.removeEventListener(event, resetTimer)
    //         );
    //         document.removeEventListener("visibilitychange", handleVisibilityChange);
    //         clearTimeout(timerRef.current);
    //     };
    // }, []);

    // handle toggle left navigation 
    const _handleToggle = () => {
        setToggle(prev => !prev);
    };


    return (
        <ErrorBoundary>
            <Fragment>
                {TOKEN ?
                    <Router>
                        {
                            showLoading === true ?
                                <div className='d-flex align-items-center justify-content-center min-vh-100'>
                                    <img src={require("./Assets/Image/loader.gif")}
                                        draggable={false}
                                        width={80}
                                        height={80}
                                        alt='loader'
                                        className='text-center' />
                                </div>

                                :
                                <div className='e-bg-magnolia'>
                                    <div className='container-fluid  min-vh-100'>
                                        <div className='row'>
                                            <div className={`${toggle ? 'col-1' : 'col-2 e-col-2'} px-0 transition`}>
                                                <LeftNavigation toggled={toggle} />
                                            </div>
                                            <div className={`${toggle ? 'col-11' : 'col-10 e-col-10'} px-0 transition`}>
                                                <Header handleToggle={_handleToggle} />
                                                <Routes>

                                                    <Route exact path="/" element={<ProtectedRoute path="/" element={<Dashboard />} />} />
                                                    <Route exact path="/ops">
                                                        <Route index element={<ProtectedRoute path="/ops" element={<OpsDashboard />} />} />
                                                        <Route path='cron-history' element={<ProtectedRoute path="/ops" element={<CronStatusHistory />} />} />
                                                        <Route path='api-history' element={<ProtectedRoute path="/ops" element={<ApiHistory />} />} />
                                                    </Route>

                                                    <Route path="notifications" element={<Notifications />} />

                                                    <Route path="/orders" >
                                                        <Route index element={<ProtectedRoute path="/orders" element={<OrderList />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/orders" element={<OrderDetail />} />} />
                                                        <Route path='goal-order-detail' element={<ProtectedRoute path="/orders" element={<GoalOrderDetail />} />} />
                                                        <Route path='fund-order-detail' element={<ProtectedRoute path="/orders" element={<FundOrderDetail />} />} />
                                                    </Route>

                                                    <Route path="/sip" element={<ProtectedRoute path="/sip" element={<SIP />} />} />
                                                    <Route path="/swp" element={<ProtectedRoute path="/sip" element={<SWP />} />} />
                                                    <Route path="/stp" element={<ProtectedRoute path="/sip" element={<STP />} />} />

                                                    <Route path="/baskets" >
                                                        <Route index element={<ProtectedRoute path="/baskets" element={<BasketListing />} />} />
                                                        <Route path='rebalance-history' element={<ProtectedRoute path="/baskets" element={<RebalanceHistory />} />} />
                                                        <Route path='manage-basket' element={<ProtectedRoute path="/baskets" element={<ManageBasket />} />} />
                                                    </Route>
                                                    <Route path="/customers">
                                                        <Route index element={<ProtectedRoute path="/customers" element={<List />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/customers" element={<CustomerDetail />} />} />
                                                        <Route path='group-detail' element={<ProtectedRoute path="/customers" element={<GroupDetail />} />} />
                                                    </Route>
                                                    <Route path="/push-notification">
                                                        <Route index element={<ProtectedRoute path="/push-notification" element={<PushNotifications />} />} />
                                                        <Route path='manage' element={<ProtectedRoute path="/push-notification" element={<CreatePushNotification />} />} />
                                                    </Route>

                                                    <Route path="/risk-assessment">
                                                        <Route index element={<ProtectedRoute path="/risk-assessment" element={<QuestionList />} />} />
                                                        <Route path='edit-log' element={<ProtectedRoute path="/risk-assessment" element={<EditLog />} />} />
                                                        <Route path='manage-risk' element={<ProtectedRoute path="/risk-assessment" element={<ManageRisk />} />} />
                                                        <Route path='manage-questionnaire' element={<ProtectedRoute path="/risk-assessment" element={<ManageQuestionnaire />} />} />
                                                    </Route>

                                                    <Route path="/monthly-reports">
                                                        <Route index element={<ProtectedRoute path="/monthly-reports" element={<Reports />} />} />
                                                    </Route>

                                                    <Route path="/send-mail">
                                                        <Route index element={<ProtectedRoute path="/send-mail" element={<SendMail />} />} />
                                                        <Route path='manage-template' element={<ProtectedRoute path="/send-mail" element={<ManageTemplate />} />} />
                                                        <Route path='manage-mail' element={<ProtectedRoute path="/send-mail" element={<ManageMail />} />} />
                                                    </Route>

                                                    {/* <Route path="/general-content">
                                            <Route index element={<GeneralContent />} />
                                        </Route> */}

                                                    <Route path="/leads">
                                                        <Route index element={<ProtectedRoute path="/leads" element={<LeadsList />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/leads" element={<LeadDetail />} />} />
                                                    </Route>

                                                    <Route exact path="/other-transactions" element={<ProtectedRoute path="/other-transactions" element={<OtherTransactionsList />} />} />

                                                    <Route path='/manage-banner' element={<ProtectedRoute path="/manage-banner" element={<ManageBanner />} />} />

                                                    <Route path="/documents">
                                                        <Route index element={<ProtectedRoute path="/documents" element={<DocumentList />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/documents" element={<DocumentDetail />} />} />
                                                    </Route>

                                                    <Route path="/sub-admins">
                                                        <Route index element={<ProtectedRoute path="/sub-admins" element={<SubAdminList />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/sub-admins" element={<AdminDetail />} />} />
                                                    </Route>

                                                    <Route path="/support">
                                                        <Route index element={<ProtectedRoute path="/support" element={<CustomerSupport />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/support" element={<CustomerDetail />} />} />
                                                    </Route>

                                                    <Route path="/prime-data">
                                                        <Route index element={<ProtectedRoute path="/prime-data" element={<PrimeData />} />} />
                                                    </Route>

                                                    <Route path="/non-kyc-nri">
                                                        <Route index element={<ProtectedRoute path="/non-kyc-nri" element={<NonKyc />} />} />
                                                        <Route path=':id' element={<ProtectedRoute path="/non-kyc-nri" element={<NonKycDetail />} />} />
                                                    </Route>

                                                    <Route path="/config">
                                                        <Route index element={<ProtectedRoute path="/config" element={<Config />} />} />
                                                    </Route>

                                                    <Route path="/fund-scheme">
                                                        <Route index element={<ProtectedRoute path="/fund-scheme" element={<FundSchemeList />} />} />
                                                    </Route>

                                                    <Route path="*" element={<PageNotFound />} />
                                                </Routes>
                                                <Footer type={1} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }

                    </Router>

                    :
                    <div className='min-vh-100 d-flex flex-column justify-content-between e-bg-primary-gradient'>
                        <Router>
                            <Routes>
                                <Route exact path="/" element={<Login />} />
                                <Route exact path="/forgot-password" element={<ForgotPassword />} />
                                <Route exact path="/set-password" element={<SetPassword />} />
                                <Route exact path="*" element={<Login />} />
                            </Routes>
                        </Router>
                        <Footer type={2} />
                    </div>

                }
                <Toast />
            </Fragment>
        </ErrorBoundary>
    );
}

export default App;